module.exports = __webpack_public_path__ + "assets/e55e6934f57ae711bd42bd89bd5937e9.jpg";